import { render, staticRenderFns } from "./djgsp.vue?vue&type=template&id=c39ab824&scoped=true"
import script from "./djgsp.vue?vue&type=script&lang=js"
export * from "./djgsp.vue?vue&type=script&lang=js"
import style0 from "./djgsp.vue?vue&type=style&index=0&id=c39ab824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39ab824",
  null
  
)

export default component.exports